
















import Vue from 'vue'
import Component from 'vue-class-component'
import Confirm from '@/components/Confirm.vue'

@Component({
  components: {
    Confirm
  },
  props: {
    hmoName: {
      type: String
    }
  }
})
export default class DeleteHMOModal extends Vue {
}
